<div class="info-action dropdown-content-root">
	<div class="dropdown-title">
		<p class="title">{{ 'positionInfo.dropdownTitle' | translate }}</p>

		<tui-icon
			class="icon"
			icon="@tui.x"
			(click)="onCloseDropdown()"
		/>
	</div>

	<div class="dropdown-subtitle">
		<div
			class="left"
			[tuiSkeleton]="isLoadingAssetInfo()"
		>
			<app-company-logo
				[logoSrc]="assetsInfo()?.icon"
				[symbol]="position()?.symbol"
				logoWidth="36px"
				logoHeight="36px"
				[logoAlt]="position()?.symbol"
			/>
			<div class="name">
				<div class="top">
					<p class="ticker">{{ assetsInfo()?.ticker || position()?.symbol }}</p>
					<p class="exchange">{{ assetsInfo()?.exchange || position()?.exchange }}</p>
				</div>
				<p class="description">{{ assetsInfo()?.description }}</p>
			</div>
		</div>

		<div
			class="right"
			[tuiSkeleton]="isLoadingLiveTicker()"
		>
			<span class="value">{{ tickerPrices?.price | price }}</span>

			<div class="statistic">
				@if (tickerPrices?.changeMoney || tickerPrices?.changePercent !== 0) {
					<app-profit-triangle [value]="tickerPrices?.changeMoney ?? 0" />
				}
				<span
					class="value"
					highlight
					[isPositive]="(tickerPrices?.changeMoney ?? 0) > 0"
					[isNegative]="(tickerPrices?.changeMoney ?? 0) < 0"
					[isNeutral]="(tickerPrices?.changeMoney ?? 0) === 0"
				>
					{{ tickerPrices?.changeMoney | price }}
				</span>
				<span
					class="value"
					highlight
					[isPositive]="(tickerPrices?.changePercent ?? 0) >= 0"
					[isNegative]="(tickerPrices?.changePercent ?? 0) < 0"
					[isNeutral]="(tickerPrices?.changePercent ?? 0) === 0"
				>
					{{ tickerPrices?.changePercent | profit: 'percent' }}
				</span>
			</div>
		</div>
	</div>

	<div class="detail profit">
		<div class="title-box">
			<p class="title">{{ 'positionInfo.profitToday' | translate }},</p>
			<span class="currency">{{ 'positionInfo.USD' | translate }}</span>
		</div>
		<div class="right">
			<span
				highlight
				[isPositive]="+(position()?.unrealized_intraday_pl ?? 0) > 0"
				[isNegative]="+(position()?.unrealized_intraday_pl ?? 0) < 0"
				[isNeutral]="+(position()?.unrealized_intraday_pl ?? 0) === 0"
				class="value"
				>{{ +(this.position()?.unrealized_intraday_pl ?? 0) | profit: 'dollar' }}</span
			>
			<span class="value percent">{{
				+(this.position()?.unrealized_intraday_plpc ?? 0) * 100 | profit: 'percent'
			}}</span>
		</div>
	</div>

	<div class="detail profit">
		<div class="title-box">
			<p class="title">{{ 'positionInfo.profitAllTime' | translate }},</p>
			<span class="currency">{{ 'positionInfo.USD' | translate }}</span>
		</div>
		<div class="right">
			<span
				highlight
				[isPositive]="+(position()?.unrealized_pl ?? 0) > 0"
				[isNegative]="+(position()?.unrealized_pl ?? 0) < 0"
				[isNeutral]="+(position()?.unrealized_pl ?? 0) === 0"
				class="value"
				>{{ +(this.position()?.unrealized_pl ?? 0) | profit: 'dollar' }}</span
			>
			<span class="value percent">{{ +(this.position()?.unrealized_plpc ?? 0) * 100 | profit: 'percent' }}</span>
		</div>
	</div>

	<div class="details">
		<div class="detail">
			<p class="title">{{ 'positionInfo.type' | translate }}</p>
			<span
				highlight
				class="value"
				[isPositive]="position()?.side === positionSideEnum.LONG"
				[isNegative]="position()?.side === positionSideEnum.SHORT"
				>{{ position()?.side || '-' | uppercase }}</span
			>
		</div>

		<div class="detail">
			<p class="title">{{ 'positionInfo.entryPrice' | translate }}</p>
			<span class="value">{{ position()?.avg_entry_price | price }}</span>
		</div>

		<div class="detail">
			<p class="title">{{ 'positionInfo.quantity' | translate }}</p>
			<span class="value">{{ position()?.qty | quantity }}</span>
		</div>

		<div class="detail">
			<p class="title">{{ 'positionInfo.balanceSheet' | translate }}</p>
			<span class="value">{{ position()?.cost_basis | price }}</span>
		</div>
		<div class="detail">
			<p class="title">{{ 'positionInfo.currentPrice' | translate }}</p>
			<span class="value">{{ position()?.current_price | price }}</span>
		</div>

		<div class="detail">
			<p class="title">{{ 'positionInfo.currentCost' | translate }}</p>
			<span class="value">{{ position()?.market_value | price }}</span>
		</div>

		<div class="detail">
			<p class="title">{{ 'positionInfo.share' | translate }}</p>
			<span class="value">{{ this.position()?.portfolio_allocation | percent: true }}</span>
		</div>
	</div>
</div>
